// Vendors
import { objectUtils } from '@openbank/cf-ui-architecture-core';
// Types
import { InternationalizationResolverType } from './types/internationalization.resolvers.type';
import { LanguageServiceResponseType } from 'providers/internationalization/types/language-service-response.type';
// Utilities
import {
  fetchLanguagesConfigurationService,
  fetchLanguageService,
} from '../services/internationalization.services';
import { isValidLanguageConfiguration } from './utils/internationalization.resolvers.utils';

const fetchLanguagesConfigurationResolver = async (
  language: string
): InternationalizationResolverType => {
  const [response] = await fetchLanguagesConfigurationService(language);
  return isValidLanguageConfiguration(response) ? [response, false] : [null, true];
};

const fetchLanguageResolver = async (
  url: string
): Promise<[LanguageServiceResponseType['entries'], boolean] | [null, boolean]> => {
  const [{ entries = null } = {}] = await fetchLanguageService(url);

  return objectUtils.isValidObject(entries) ? [entries, false] : [null, true];
};

export { fetchLanguageResolver, fetchLanguagesConfigurationResolver };
